<template>
  <section class="page-container">
    <h1>Quick Quote Report</h1>
    <div
      class="btn-top-container">
      <v-button
        type="plain"
        size="mini"
        :disabled="isDisable"
        @click="handlerDown"
      >Export Excel
      </v-button>
    </div>
    <div class="filter-card">

      <div class="filter-main">
        <div class="filter-left">
          <div class="form-item">
            <span>Created</span>
            <v-date-picker
              v-model="date"
              type="daterange"
              @change="filterData" />
          </div>
          <div class="form-item flex-checkbox">
            <span>
              User Type
              <!--              <span-->
              <!--                class="all"-->
              <!--                @click="handlerSelectAll('user_type')">All</span>-->
              <!--              <span-->
              <!--                class="all"-->
              <!--                @click="handlerNoneAll('user_type')">None</span>-->
            </span>
            <v-checkbox-group
              v-model="user_type"
              :list="userTOptions"
              :block="true"
              @change="filterData"
            />
          </div>
          <div class="form-item flex-checkbox">
            <span>
              Client Type
              <!--              <span-->
              <!--                class="all"-->
              <!--                @click="handlerSelectAll('website_type')">All</span>-->
              <!--              <span-->
              <!--                class="all"-->
              <!--                @click="handlerNoneAll('website_type')">None</span>-->
            </span>
            <v-checkbox-group
              v-model="website_type"
              :list="clientOptions"
              :block="true"
              @change="filterData"
            />
          </div>
        </div>
        <div class="filter-middler">
          <div class="form-item">
            <span>
              Product Type
              <span
                class="all"
                @click="handlerSelectAll('class_id')"> All</span>
              <span
                class="all"
                @click="handlerNoneAll('class_id')">None</span>
            </span>
            <div class="flex-sb">
              <div class="form-half ">
                <span>Auto-Quote</span>
                <v-checkbox-group
                  v-model="class_id"
                  :list="classOptions"
                  :isColumn="false"
                  @change="filterData"></v-checkbox-group>
              </div>
              <div class="form-half">
                <span>SME</span>
                <v-checkbox-group
                  v-model="class_id"
                  :list="manual_quote_product.industry"
                  :isColumn="false"
                  @change="filterData"></v-checkbox-group>
              </div>
              <div class="form-half">
                <br>
                <v-checkbox-group
                  v-model="class_id"
                  :list="manual_quote_product.sme"
                  :isColumn="false"
                  @change="filterData"></v-checkbox-group>
              </div>
            </div>
          </div>
        </div>
        <!--        <div class="filter-right">-->
        <!--          <div class="form-item">-->
        <!--            <span>-->
        <!--              Type-->
        <!--              <span-->
        <!--                class="all"-->
        <!--                @click="handlerSelectAll('is_guest')">All</span>-->
        <!--              <span-->
        <!--                class="all"-->
        <!--                @click="handlerNoneAll('is_guest')">None</span>-->
        <!--            </span>-->
        <!--            <v-checkbox-group-->
        <!--              v-model="is_guest"-->
        <!--              :list="qutoteTypeOption"-->
        <!--              :block="true"-->
        <!--              @change="filterData">-->
        <!--              <template #default="{ item }">-->
        <!--                <span class="flex">-->
        <!--                  <span  class="button-border">{{ item['name'] }}</span>-->
        <!--                </span>-->
        <!--              </template>-->
        <!--            </v-checkbox-group>-->
        <!--          </div>-->
        <!--          <div class="form-item">-->
        <!--            <span>-->
        <!--              Status-->
        <!--              <span-->
        <!--                class="all"-->
        <!--                @click="handlerSelectAll('stts')">All</span>-->
        <!--              <span-->
        <!--                class="all"-->
        <!--                @click="handlerNoneAll('stts')">None</span>-->
        <!--            </span>-->
        <!--            <v-checkbox-group-->
        <!--              v-model="stts"-->
        <!--              :list="quoteStautsOption"-->
        <!--              :block="true"-->
        <!--              @change="filterData">-->
        <!--              <template #default="{ item }">-->
        <!--                <span class="flex">-->
        <!--                  <span-->
        <!--                    class="circle"-->
        <!--                    :class="{-->
        <!--                      'yellow-dark': [4, 7].includes(item.id),-->
        <!--                      'blue': [1, 5].includes(item.id),-->
        <!--                      'red': [6].includes(item.id),-->
        <!--                      'purple': [3].includes(item.id)-->
        <!--                    }"></span>-->
        <!--                  <span>{{ item['name'] }}</span>-->
        <!--                </span>-->
        <!--              </template>-->
        <!--            </v-checkbox-group>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
    </div>
    <div class="transparent">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-row-class-name="'tableHeader'"
        @row-click="rowClick">
        <el-table-column
          prop="quote_dt"
          width="160"
          label="Created">
          <!--          <template #default="{ row }">-->
          <!--            <div class="flex-algin" >-->
          <!--              <span class="text-date">{{row.created_date}}</span>-->
          <!--            </div>-->
          <!--          </template>-->
          <template #default="{ row }">
            <span>{{ row.created_date.split(" ")[0] }}</span><br>

            <span> {{ row.created_date.split(" ")[1] }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="Product Type"
        >
          <template #default="{ row }">
            <div class="flex-algin">
              <div class="flex margin-top-flex">
                <span
                  v-if="![63,64,65,66,67,68,69,70].includes(row.class_id)"
                  class="icon icon-content"
                >
                  <font-awesome-icon
                    v-if="row.class_id"
                    v-tooltip="row.class_language"
                    :icon="getOptionName('iconOptions', row.class_id)"  />
                </span>
                <span
                  v-else
                  class="content-pending"></span>
                <span>{{row.class_language}}</span>

              </div>
              <p></p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="Special Type">
          <template #default="{ row }">
            <div class="flex-algin">
              <span  >{{row.special_type_language}}</span>
              <p></p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="Car Make">
          <template #default="{ row }">
            <div class="flex-algin">
              <span  >{{row.brand}}</span>
              <p></p>
            </div>
          </template>
        </el-table-column>
        <!--        <el-table-column-->
        <!--          prop="insurer"-->
        <!--          label="Insurer"></el-table-column>-->
        <el-table-column
          prop="price"
          label="User Type">
          <template #default="{ row }">
            <div class="flex-algin">
              <span>{{row.user_type_language}}</span>
              <p></p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="contact_nm"
          label="Client">
          <template #default="{ row }">
            <div class="flex-algin">
              <span>
                {{ row.website_language }}
              </span>
              <p></p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="User Info">
          <template #default="{ row }">
            <div class="flex-algin">
              <span>
                {{ row.user_login }}
              </span>
              <p></p>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange" />
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import {mapActions, mapState} from 'vuex'
import {getStatisticsList, getStatisticsDownload} from '@/api/statistic'
import {downloadFile} from '@/utils/download'

export default {
  name: 'quickQuoteReport',

  mixins: [MixinOptions],
  props:{

  },
  data() {
    return {
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      },
      // // todo
      // statusOptions: [
      //   {
      //     name: 'Quick Quote',
      //     id: 1
      //   },
      //   {
      //     name: 'Paid',
      //     id: 2
      //   }
      // ],
      date: '',
      user_type: [],
      class_id: [],
      website_type: [],
      search: '',
      tableData: []
    }
  },
  computed:{
    ...mapState('filter', ['selectFilterData']),
    isDisable(){
      return this.user_type.length<=0&&this.class_id.length<=0&&this.website_type.length<=0&&!this.date
    },
    manual_quote_product(){
      return this.globalOptions.manual_quote_product
    }
  },
  watch: {
    property: {
      immediate: true,
      handler() {
        this.network().getOrderList()
      }
    }
  },
  methods: {
    ...mapActions('quote', ['setIsBack']),
    handlerDown(){
      this.network().getReportDownload()
    },
    rowClick(row) {
      // this.setIsBack(null)
      // this.$router.push({
      //   path: '/records/quote/detail',
      //   query: {
      //     order_id: row.id,
      //     product_id: row.product_id
      //   }
      // })
    },
    handlerSelectAll(target) {
      let origin = ''
      switch(target) {
        case 'class_id':
          origin = 'classOptions'
          break
        case 'website_type':
          origin = 'clientOptions'
          break
        case 'user_type':
          origin = 'userTOptions'
          break
      }
      let data = this[origin].reduce((result, item) => {
        result.push(item.id)
        return result
      }, [])

      if(target=='class_id'){
        let arr =[]
        Object.keys(this.manual_quote_product).forEach((name)=>{
          this.manual_quote_product[name].reduce((res,item)=>{
            arr.push(item.id)
          },[])
        })
        data = [...data,...arr]
      }

      this[target] = data
      this.filterData()
    },
    handlerNoneAll(target){
      this[target] = []
      this.filterData()
    },
    filterData() {
      this.pageConfig.currentPage = 1
      this.network().getOrderList()
    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.network().getOrderList()
    },
    network() {
      return {
        getOrderList: async () => {
          const { data } = await getStatisticsList({
            user_type: this.user_type,
            website_type: this.website_type,
            class_id: this.class_id,
            created_start: this.date[0],
            created_end: this.date[1],
            page: this.pageConfig.currentPage,
          })
          this.tableData = data.data
          this.pageConfig.total = data.total
        },
        getReportDownload: async () => {
          const res= await getStatisticsDownload({
            user_type: this.user_type,
            website_type: this.website_type,
            class_id: this.class_id,
            created_start: this.date[0],
            created_end: this.date[1],
          })
          downloadFile(res)
        },
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .page-container {
    position: relative;
    color: #303133;
    .text-date{
      font-size: 12px;
    }
    .filter-top{
      margin-bottom: 30px;
    }
    .flex-checkbox{
      ::v-deep .el-checkbox-group{
        flex-wrap: nowrap!important;
      }
    }
    .btn-top-container {
      position: absolute;
      top: 10px;
      right: 0;
    }
    h1 {
      // margin-bottom: 20px;
      font-size: 34px;
    }
    .filter-container {
      .filter-box {
        margin-bottom: 10px;
        .label {
          display: block;
          padding-bottom: 5px;
          font-size: 14px;
          font-weight: bold;
          .all {
            display: inline-block;
            padding-left: 15px;
            color: #409eff;
            font-weight: 500;
            cursor: pointer;
          }
        }
        .search-box {
          margin-right: 20px;
          width: 400px;
        }
        .quote-box {
          width: 300px;
        }
      }

    }
    .span-name {
      display: block;
      color: #24292E;
    }
    .span-label {
      display: block;
      color: #24292E;
      font-weight: 500;
    }
    .form-half {
      & > span {
        display: block;
        padding-bottom: 5px;
        font-size: 14px;
        color: #6a737d;
      }
    }
    .span-status {
      display: inline-block;
      margin-right: 15px;
      padding: 5px 10px;
      border-radius: 12px;
      font-size: 12px;
      line-height: 14px;
      color: white;
      font-weight: 500;
      .svg-inline--fa {
        margin-right: 5px;
        font-size: 14px;
      }
      &.green {
        background: #28a745;
        color: white;
      }
      &.orange {
        background: #E36209;
        color: white;
      }
      &.yellow-dark {
        background: #DBAB09,
      }
      &.blue {
        background: #0366D6;
      }
      &.red {
        background: #d73a49;
      }
      &.min-green {
        background: #dcffe4;
        color: #28a745;
      }
    }
    .filter-card {
      margin-bottom: 30px;
      margin-top: 15px;
      background: white;
      border: 1px solid #E1E4E8;
      border-radius: 5px;
      .filter-top {
        display: flex;
        align-items: center;
        padding: 15px;
        border-bottom: 1px solid #E1E4E8;
        & > span {
          display: inline-block;
          padding-right: 10px;
        }
      }
      .filter-main {
        display: flex;
        padding: 0 15px;
        .all {
          display: inline-block;
          padding-left: 15px;
          color: #409eff;
          cursor: pointer;
        }
        .filter-left, .filter-middler, .filter-right {
          padding: 15px 0;
        }
        .filter-left {
          padding-right: 10px;
          width: 290px;
          min-width: 290px;
        }
        .filter-middler {
          padding: 15px 10px;
          border-left: 1px solid #E1E4E8;
          /*border-right: 1px solid #E1E4E8;*/
          width: 100%;
        }
        .filter-right {
          padding-left: 10px;
        }
      }
      .circle {
        display: inline-block;
        margin-right: 5px;
        width: 14px;
        height: 14px;
        min-width: 14px;
        min-height: 14px;
        border-radius: 100%;
        &.orange-light {
          background: #E36209;
        }
        &.yellow-dark {
          background: #DBAB09;
        }
        &.blue {
          background: #0366D6;
        }
        &.green {
          background: #28A745;
        }

        &.red {
          background: #D73A49;
        }
      }
    }
    .purple {
      background: #6F42C1;
    }
    ::v-deep .el-table{
      border-radius: 4px;
      border: 1px solid #E1E4E8;
    }
    ::v-deep .tableHeader {
      margin-top: 30px;
      background: #F6F8FA !important;
      border-bottom: 1px solid #E1E4E8;
      th {
        background-color: #F6F8FA !important;
        font-family: Inter;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        letter-spacing: -0.15px;
        /* Text/text-gray-dark */
        color: #24292E!important;
      }
    }
    .button-border{
      display: inline-block;
      padding: 0px 10px;
      height: auto;
      //line-height: 30px;
      font-size: 12px;
      border-radius: 50px;
      border: 1px solid #E1E4E8;
      color: #24292E;
      background: white;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 18px;

    }
    .margin-top-flex{
      margin-top: 5px;
      .icon{
        margin-right: 10px;
        img{
          height: 22px;
          width: 22px;
        }
      }
      .icon-content{
        height: 22px;
        width: 22px;
        border-radius: 5px;
        background-color: #E1E4E8;
        color: #6A737D;
        font-size: 14px;
        text-align: center;
        line-height: 22px;
      }
      .content-pending{
        height: 22px;
        width: 22px;
        margin-right: 10px;
      }
    }
    .el-table{
      ::v-deep .flex-algin{
        display: flex;
        flex-direction: column;
        justify-content:space-between ;
        p{
          height: 24px;
        }
      }
      p:first-child{
        color: #24292E;
        font-size: 14px;
        font-weight: 500;
      }
      .login-text{
        color: #24292E;
        font-family: Inter;
        font-size: 14px;
        letter-spacing: 0;
        line-height: 17px;
      }
      .liter-text{
        color: #6A737D;
        font-family: Inter;
        font-size: 12px;
        letter-spacing: 0;
        line-height: 15px;
      }
    }
  }
</style>
